import { useSelector } from 'react-redux';
import { selectPassengerAncillaries } from 'selectors/purchaseSelectors';

/**
 * usePassengerAncillaries hook.
 * Returns ancillaries for a specific passenger and segment from the purchase state.
 * Ancillaries contain complete information (code, quantity, name, price) from the service.
 *
 * @param {number|string} passengerId - ID of the passenger
 * @param {string} segment - Segment: 'outgoing' or 'incoming'
 * @returns {Array} Array of ancillaries with code, quantity, name, and price
 */
export const usePassengerAncillaries = (passengerId, segment = 'outgoing') => {
  return useSelector(selectPassengerAncillaries(passengerId, segment));
};

export default usePassengerAncillaries;
